var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0833 2.89655C15.25 1.07586 12.75 0 10 0C7.25 0 4.75 1.07586 2.91667 2.89655C1.08333 4.71724 0 7.2 0 9.93104C0 12.6621 1.08333 15.1448 2.91667 16.9655L10 24L17.0833 16.9655C18.9167 15.1448 20 12.6621 20 9.93104C20 7.2 18.9167 4.71724 17.0833 2.89655ZM10 12.4138C8.58333 12.4138 7.5 11.3379 7.5 9.93104C7.5 8.52414 8.58333 7.44828 10 7.44828C11.4167 7.44828 12.5 8.52414 12.5 9.93104C12.5 11.3379 11.4167 12.4138 10 12.4138Z",
    fill: "#7363F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.769e8c48930851c0143f27c73ffc20b6.svg";
export { ForwardRef as ReactComponent };